export const DiaLogMixin = {
    data() {
        return {
            showTag: false
        }
    },
    methods: {
        show() {
            this.showTag = true;
        },
        hide() {
            this.showTag = false;
        }
    },
}
